import { BaseDTO } from './basedto';
import { IProposalEffectivity } from './interfaces/IProposalEffectivity.interface';
import { ProposalEffectivityHistory } from './proposaleffectivityhistory';

export class ProposalEffectivity extends BaseDTO
    implements IProposalEffectivity {
    ProposalId: number;
    EffectiveFrom: Date;
    EffectiveTo: Date;
    History: ProposalEffectivityHistory[];
    /**
     *
     */
    constructor() {
        super();
    }
}
